import { FC, useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";

import { BodySmall, Box, Modal, ModalFooter, ModalHeader, Select, SelectChangeEvent } from "@parspec/pixel";

import { useGetBomSectionsQuery, useOptionSectionQuery } from "../queries";

interface SelectSectionModalProps {
    isOptionTable: boolean;
    open: boolean;
    onClose: () => void;
    title: string;
    subTitle?: string;
    onSubmit: (sectionId: number) => void;
    isLoading?: boolean;
}

const SelectSectionModal: FC<SelectSectionModalProps> = ({ isOptionTable, open, onClose, title, subTitle, onSubmit, isLoading }) => {
    const { bomId } = useParams();
    const [selectedSection, setSelectedSection] = useState<string | number>('')

    const { data: sectionData, isLoading: sectionDataLoading } = useGetBomSectionsQuery(Number(bomId), {
        enabled: Boolean(bomId)
    });

    const { data: optionSectionData, isLoading: optionDataLoading } = useOptionSectionQuery(Number(bomId), {
        enabled: Boolean(bomId)
    });

    const sectionsDropdownOptions = useMemo(() => {
        const options = isOptionTable ? (optionSectionData?.data || []) : (sectionData?.data || [])
        return options.map((item) => ({ name: item.name, id: item.id }));
    }, [sectionData?.data, optionSectionData?.data, isOptionTable]);

    useEffect(() => {
        if (sectionsDropdownOptions.length) {
            setSelectedSection(sectionsDropdownOptions?.[0]?.id)
        }
    }, [sectionsDropdownOptions])

    const isDisabled = sectionDataLoading || optionDataLoading || !Boolean(selectedSection)

    return (
        <Modal header={<ModalHeader title={title} onClose={onClose} children={subTitle ? <BodySmall color={'text.secondary'}>{subTitle}</BodySmall> : <></>} />} footer={<ModalFooter
            onReject={() => {
                onClose()
            }}
            onAccept={() => onSubmit(Number(selectedSection))}
            continueButtonLabel="Confirm"
            disabled={isDisabled}
            isLoading={isLoading}

        />} open={open}>
            <Box width="400px" position="relative" height={'100%'}>
                <Box mt={4} width='60%'>
                    <Select
                        label=""
                        onChange={(e: SelectChangeEvent<unknown>) => setSelectedSection(e.target.value as string)}
                        options={sectionsDropdownOptions}
                        optionLabelKeyname="name"
                        optionValueKeyname="id"
                        value={selectedSection}
                    />
                </Box>
            </Box>
        </Modal>
    )

}

export default SelectSectionModal